<script setup lang="ts">
  import { mdiCalendarBlank } from '@mdi/js'
  import MdiIcon from '@/common/components/svg/MdiIcon.vue'
  import { format, parseISO } from '@/common/services/time'

  defineProps({
    date: {
      type: String,
      required: true
    }
  })

  function formatDate (input: string) {
    const date = parseISO(input)
    return format(date, 'dd. MMMM')
  }
</script>

<template>
  <div class="rounded px-3 py-1 h-7 border border-gray-300 shadow-sm bg-white inline-flex gap-2 items-center">
    <div>
      <MdiIcon :icon="mdiCalendarBlank" class="size-4 text-gray-500" />
    </div>
    <div>
      {{ formatDate(date) }}
    </div>
  </div>
</template>